import axios from './'

export function solutionAdvisorySubmit<T>(params: T){
  return axios.post('/official/solutionAdvisorySubmit', params)
}
